import Patient from 'interfaces/Patient';
import User from 'interfaces/User';

export default function isPatient(user: User): user is Patient {
  return (user as Patient).patientPathologies !== undefined;
}
